import { AxiosPromise } from 'axios';
import { IGetSidemenu, IGetPermits, IPermitReq } from '../models/permission.model';
import axios from 'axios';

const uri = '/mgmt/permission';

export const getSidemenu = (): AxiosPromise<IGetSidemenu> => {
  return axios.get(`${uri}/menus`);
}

export const getPermits = (groupNo: number, menuCode: number): AxiosPromise<IGetPermits> => {
  return axios.get(`${uri}/${groupNo}/menus/${menuCode}`);
}

export const createPermits = (groupNo: number, menuCode: number, data: IPermitReq[]): AxiosPromise => {
  return axios.post(`${uri}/${groupNo}/menus/${menuCode}`, data);
};
